// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-stepper::ng-deep {
  direction: rtl;
}
mat-stepper::ng-deep .mat-horizontal-stepper-header,
mat-stepper::ng-deep .mat-vertical-stepper-header {
  pointer-events: none !important;
}
mat-stepper::ng-deep .mat-vertical-stepper-header .mat-step-icon {
  margin-left: 50px;
}
mat-stepper::ng-deep .mat-stepper-vertical-line::before {
  content: "";
  right: 50px;
  left: unset;
}

.example-accordion {
  display: block;
  max-width: 90%;
  margin-bottom: 23px;
  background-color: #e7e7e7;
  margin-left: 80px;
}

.example-accordion-item {
  display: block;
  border: solid 1px #ccc;
}

.example-accordion-item + .example-accordion-item {
  border-top: none;
}

.example-accordion-item-header {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.example-accordion-item-description {
  font-size: 0.85em;
  color: #999;
}

.example-accordion-item-header,
.example-accordion-item-body {
  padding: 16px;
}

.example-accordion-item-header:hover {
  cursor: pointer;
  background-color: #eee;
}

.example-accordion-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.example-accordion-item:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.item-title {
  font-size: small;
}

img {
  height: 100px;
  width: 100px;
  margin: auto;
}

mat-card.mat-mdc-card.mdc-card.image-step {
  height: 120px;
  width: 120px;
}

.parent-user {
  display: flex;
  justify-content: end;
}

.item-user {
  display: flex;
  direction: rtl;
}

.item-right {
  margin-right: 20px;
  margin-left: 20px;
  margin-right: 25px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: small;
  color: blue;
}

.item-left {
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: small;
}

.parent-step {
  display: flex;
  direction: rtl;
}

.item-contract {
  width: 50%;
  margin-right: 6rem;
  margin-top: 50px;
}

textarea {
  resize: vertical;
  width: 80%;
  height: 145px;
}

.text-contract {
  font-size: small;
  color: blue;
  margin-right: 10px;
}

.button-back {
  margin-bottom: 20px;
  margin-left: 20px;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

h1 {
  font-size: larger;
}`, "",{"version":3,"sources":["webpack://./src/app/features/services/services-tracking/services-tracking.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/services/services-tracking/services-tracking.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;ACCJ;ADCI;;EAEI,+BAAA;ACCR;ADGQ;EACI,iBAAA;ACDZ;ADKI;EACI,WAAA;EACA,WAAA;EACA,WAAA;ACHR;;ADOA;EACI,cAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;ACJJ;;ADOA;EACI,cAAA;EACA,sBAAA;ACJJ;;ADOA;EACI,gBAAA;ACJJ;;ADOA;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;ACJJ;;ADOA;EACI,iBAAA;EACA,WAAA;ACJJ;;ADOA;;EAEI,aAAA;ACJJ;;ADOA;EACI,eAAA;EACA,sBAAA;ACJJ;;ADOA;EACI,2BAAA;EACA,4BAAA;ACJJ;;ADOA;EACI,8BAAA;EACA,+BAAA;ACJJ;;ADOA;EACI,gBAAA;ACJJ;;ADMA;EACI,aAAA;EACA,YAAA;EACA,YAAA;ACHJ;;ADKA;EACI,aAAA;EACA,YAAA;ACFJ;;ADIA;EACI,aAAA;EACA,oBAAA;ACDJ;;ADGA;EACI,aAAA;EACA,cAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,aAAA;EACA,cAAA;ACAJ;;ADEA;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;;ADCA;EACI,gBAAA;EACA,UAAA;EACA,aAAA;ACEJ;;ADAA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;ACGJ;;ADDA;EACI,mBAAA;EACA,iBAAA;ACIJ;;ADFA;EACI,aAAA;EACA,YAAA;EACA,aAAA;ACKJ;;ADFA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACKJ;;ADFA;EACI,iBAAA;ACKJ","sourcesContent":["mat-stepper::ng-deep {\r\n    direction: rtl;\r\n\r\n    .mat-horizontal-stepper-header,\r\n    .mat-vertical-stepper-header {\r\n        pointer-events: none !important;\r\n    }\r\n\r\n    .mat-vertical-stepper-header {\r\n        .mat-step-icon {\r\n            margin-left: 50px;\r\n        }\r\n    }\r\n\r\n    .mat-stepper-vertical-line::before {\r\n        content: \"\";\r\n        right: 50px;\r\n        left: unset;\r\n    }\r\n}\r\n\r\n.example-accordion {\r\n    display: block;\r\n    max-width: 90%;\r\n    margin-bottom: 23px;\r\n    background-color: #e7e7e7;\r\n    margin-left: 80px;\r\n}\r\n\r\n.example-accordion-item {\r\n    display: block;\r\n    border: solid 1px #ccc;\r\n}\r\n\r\n.example-accordion-item+.example-accordion-item {\r\n    border-top: none;\r\n}\r\n\r\n.example-accordion-item-header {\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.example-accordion-item-description {\r\n    font-size: 0.85em;\r\n    color: #999;\r\n}\r\n\r\n.example-accordion-item-header,\r\n.example-accordion-item-body {\r\n    padding: 16px;\r\n}\r\n\r\n.example-accordion-item-header:hover {\r\n    cursor: pointer;\r\n    background-color: #eee;\r\n}\r\n\r\n.example-accordion-item:first-child {\r\n    border-top-left-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n}\r\n\r\n.example-accordion-item:last-child {\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n\r\n.item-title {\r\n    font-size: small;\r\n}\r\nimg {\r\n    height: 100px;\r\n    width: 100px;\r\n    margin: auto;\r\n}\r\nmat-card.mat-mdc-card.mdc-card.image-step {\r\n    height: 120px;\r\n    width: 120px;\r\n}\r\n.parent-user{\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n.item-user{\r\n    display: flex;\r\n    direction: rtl;\r\n    \r\n}\r\n.item-right{\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    margin-right: 25px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    font-size: small;\r\n    color: blue;\r\n}\r\n\r\n.item-left{\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    font-size: small;\r\n\r\n}\r\n.parent-step{\r\n    display: flex;\r\n    direction: rtl;\r\n}\r\n.item-contract {\r\n    width: 50%;\r\n    margin-right: 6rem;\r\n    margin-top: 50px;\r\n}\r\ntextarea {\r\n    resize: vertical;\r\n    width: 80%;\r\n    height: 145px;\r\n}\r\n.text-contract{\r\n    font-size: small;\r\n    color: blue;\r\n    margin-right: 10px;\r\n}\r\n.button-back{\r\n    margin-bottom: 20px;\r\n    margin-left: 20px;\r\n}\r\n.parent-both {\r\n    display: flex;\r\n    margin: auto;\r\n    padding: 20px;\r\n}\r\n\r\n.title {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\nh1 {\r\n    font-size: larger;\r\n}","mat-stepper::ng-deep {\n  direction: rtl;\n}\nmat-stepper::ng-deep .mat-horizontal-stepper-header,\nmat-stepper::ng-deep .mat-vertical-stepper-header {\n  pointer-events: none !important;\n}\nmat-stepper::ng-deep .mat-vertical-stepper-header .mat-step-icon {\n  margin-left: 50px;\n}\nmat-stepper::ng-deep .mat-stepper-vertical-line::before {\n  content: \"\";\n  right: 50px;\n  left: unset;\n}\n\n.example-accordion {\n  display: block;\n  max-width: 90%;\n  margin-bottom: 23px;\n  background-color: #e7e7e7;\n  margin-left: 80px;\n}\n\n.example-accordion-item {\n  display: block;\n  border: solid 1px #ccc;\n}\n\n.example-accordion-item + .example-accordion-item {\n  border-top: none;\n}\n\n.example-accordion-item-header {\n  display: flex;\n  align-content: center;\n  justify-content: space-between;\n}\n\n.example-accordion-item-description {\n  font-size: 0.85em;\n  color: #999;\n}\n\n.example-accordion-item-header,\n.example-accordion-item-body {\n  padding: 16px;\n}\n\n.example-accordion-item-header:hover {\n  cursor: pointer;\n  background-color: #eee;\n}\n\n.example-accordion-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.example-accordion-item:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.item-title {\n  font-size: small;\n}\n\nimg {\n  height: 100px;\n  width: 100px;\n  margin: auto;\n}\n\nmat-card.mat-mdc-card.mdc-card.image-step {\n  height: 120px;\n  width: 120px;\n}\n\n.parent-user {\n  display: flex;\n  justify-content: end;\n}\n\n.item-user {\n  display: flex;\n  direction: rtl;\n}\n\n.item-right {\n  margin-right: 20px;\n  margin-left: 20px;\n  margin-right: 25px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: small;\n  color: blue;\n}\n\n.item-left {\n  margin-right: 20px;\n  margin-left: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: small;\n}\n\n.parent-step {\n  display: flex;\n  direction: rtl;\n}\n\n.item-contract {\n  width: 50%;\n  margin-right: 6rem;\n  margin-top: 50px;\n}\n\ntextarea {\n  resize: vertical;\n  width: 80%;\n  height: 145px;\n}\n\n.text-contract {\n  font-size: small;\n  color: blue;\n  margin-right: 10px;\n}\n\n.button-back {\n  margin-bottom: 20px;\n  margin-left: 20px;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nh1 {\n  font-size: larger;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
